import React, { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  // Initialize the state with an object that includes both isLoggedIn and mobile
  const [user, setUser] = useState({
    isLoggedIn: false,
    userType: null, // 'customer' or 'employee'
    mobile: null, // Initially, there is no mobile number until the user logs in
  });

  const login = (mobile, userType) => {
    setUser({ isLoggedIn: true, userType, mobile });
  };

  const logout = () => {
    // Reset the user state on logout
    setUser({ isLoggedIn: false, mobile: null, userType: null });
  };

  return (
    <AuthContext.Provider value={{ ...user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
